import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Smartphone } from "lucide-react";
import AppStoreBadges from "./AppStoreBadges";
import qr from "@/assets/appstore-qr.svg";

const DownloadCTA = () => {
  const { t } = useTranslation();

  return (
    <section id="download" className="py-24 lg:py-32 relative overflow-hidden">
      <div className="container mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative max-w-6xl mx-auto rounded-[2.5rem] overflow-hidden"
        >
          <div
            className="absolute inset-0"
            style={{
              background:
                "radial-gradient(ellipse at top right, hsl(var(--brand-amber) / 0.55) 0%, transparent 55%), radial-gradient(ellipse at bottom left, hsl(var(--accent) / 0.30) 0%, transparent 55%), linear-gradient(135deg, hsl(var(--brand-forest-deep)) 0%, hsl(var(--primary)) 100%)",
            }}
          />
          <div
            className="absolute inset-0 opacity-15"
            style={{
              backgroundImage:
                "radial-gradient(circle at 2px 2px, white 1px, transparent 0)",
              backgroundSize: "28px 28px",
            }}
          />
          <motion.div
            className="absolute -top-32 -right-32 w-96 h-96 rounded-full blur-[120px]"
            style={{ background: "hsl(var(--brand-amber) / 0.45)" }}
            animate={{ scale: [1, 1.15, 1] }}
            transition={{ duration: 10, repeat: Infinity }}
          />

          <div className="relative grid lg:grid-cols-[1fr_auto] gap-10 lg:gap-16 items-center p-10 lg:p-16 text-white">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 mb-6 backdrop-blur-sm">
                <Smartphone className="w-4 h-4" />
                <span className="text-xs font-bold uppercase tracking-widest">
                  {t("download.eyebrow")}
                </span>
              </div>
              <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-5 text-balance">
                {t("download.headline")}
              </h2>
              <p className="text-lg lg:text-xl text-white/85 mb-8 max-w-xl leading-relaxed">
                {t("download.sub")}
              </p>
              <AppStoreBadges variant="dark" size="lg" location="download_cta" />

            </div>

            {/* QR for desktop */}
            <div className="hidden lg:flex flex-col items-center gap-3 bg-white rounded-3xl p-5 shadow-2xl">
              <img
                src={qr}
                alt="Scan to download PieFolio AI"
                width={176}
                height={176}
                loading="lazy"
                decoding="async"
                className="w-44 h-44"
              />

              <p className="text-xs font-bold text-foreground uppercase tracking-widest text-center">
                {t("download.scan")}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DownloadCTA;
